export default "__VITE_ASSET__BLxw9_z7__"